import { SxProps } from '@mui/material';
import { Theme } from '@mui/material/styles';

const pageStyles: {
  label: SxProps<Theme>;
  dynamicBreadcrumbs: SxProps<Theme>;
} = {
  label: {
    flex: '1 1 100%',
    margin: 3,
  },
  dynamicBreadcrumbs: {
    margin: 3,
  },
};

export default pageStyles;
